import {
  OPEN_EDIT_MENU_ITEM_DIALOG,
  CLOSE_EDIT_MENU_ITEM_DIALOG,
  SET_MENU_ID,
  UPDATE_MENU_ITEM,
  REMOVE_MENU_ID,
  GET_MENU,
  GET_CATEGORIES,
  LOADING,
  STOP_LOADING,
  DELETE_MENU_ITEM,
  STORE_FETURED_IMAGE,
  SET_IMAGE_LOADING,
  STOP_IMAGE_LOADING,
  UNSET_IMAGE_SUCCESSFULLY_UPLAODED,
  SET_IMAGE_SUCCESSFULLY_UPLAODED,
} from "../types";

import axios from "axios";

export const getMenuItems = (resID) => (dispatch) => {
  dispatch({ type: LOADING });
  axios
    .get(`/seller/getAllMenuItems/${resID}`)
    .then((res) => {
      dispatch({ type: GET_MENU, payload: res.data.menuItems });
      dispatch({ type: STOP_LOADING });
    })
    .catch((err) => console.log(err));
};

export const getCategories = () => (dispatch) => {
  axios
    .get("/seller/category")
    .then((res) => {
      dispatch({ type: GET_CATEGORIES, payload: res.data });
    })
    .catch((err) => console.log(err));
};

export const storeFeturedImage = (itemID, imageData) => (dispatch) => {
  // dispatch({ type: STORE_FETURED_IMAGE, payload: { menuItemId: itemID, imageUrl: "https://images.hdqwalls.com/download/iron-man-4k-2020-art-lw-240x320.jpg" } })
  dispatch({ type: SET_IMAGE_LOADING });
  dispatch({ type: CLOSE_EDIT_MENU_ITEM_DIALOG });

  axios
    .post(`/upload/fItem/${itemID}`, imageData)
    .then((res) => {
      // console.log(res.data);
      dispatch({
        type: STORE_FETURED_IMAGE,
        payload: { menuItemId: itemID, imageUrl: res.data.imageUrl },
      });
      dispatch({ type: SET_IMAGE_SUCCESSFULLY_UPLAODED });
      dispatch({ type: STOP_IMAGE_LOADING });
    })
    .catch((err) => console.log(err.response));
};

export const updateMenuItem = (menuItem, menuItemId) => (dispatch) => {
  const payload = {
    item: menuItem,
    menuItemId,
  };
  axios
    .post("seller/updateMenuItem", payload)
    .then((res) => {
      dispatch({ type: UPDATE_MENU_ITEM, payload: res.data.results });
      dispatch({ type: CLOSE_EDIT_MENU_ITEM_DIALOG });
      dispatch({ type: REMOVE_MENU_ID });
    })
    .catch((err) => console.log(err));
};

export const deleteMenuItem = (itemID) => (dispatch) => {
  axios
    .delete(`seller/deleteMenu/${itemID}`)
    .then((res) => {
      console.log(res.data);
      dispatch({ type: DELETE_MENU_ITEM, payload: { itemID } });
    })
    .catch((err) => console.log(err));
};

export const displayEditMenuItemDialog = () => (dispatch) => {
  dispatch({ type: OPEN_EDIT_MENU_ITEM_DIALOG });
};

export const hideEditMenuItemDialog = () => (dispatch) => {
  dispatch({ type: REMOVE_MENU_ID });
  dispatch({ type: CLOSE_EDIT_MENU_ITEM_DIALOG });
};

export const setMenuIdForDialog = (menuItemId) => (dispatch) => {
  dispatch({ type: SET_MENU_ID, payload: menuItemId });
};

export const stopImageLoading = () => (dispatch) => {
  dispatch({ type: STOP_IMAGE_LOADING });
};

export const unsetImageSuccessfullyUploaded = () => (dispatch) => {
  dispatch({ type: UNSET_IMAGE_SUCCESSFULLY_UPLAODED });
};

export const toggleIsAvailable = (itemID) => (dispatch) => {
  axios
    .post("seller/available", { meunId: itemID })
    .then((res) => {})
    .catch((err) => console.log(err.response));
};
